import { useId } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export const IconSemiCircle = ({
  width = 25,
  height = 12,
  className,
}: TIllustrationProps) => {
  const id = useId();
  return (
    <Svg
      width={width}
      height={height}
      className={className}
      fill="none"
      viewBox="0 0 25 12"
    >
      <Path fill={`url(#semicircle-a-${id})`} d="M.5 12a12 12 0 0 1 24 0H.5Z" />
      <Defs>
        <LinearGradient
          id={`semicircle-a-${id}`}
          x1=".5"
          x2="10.1"
          y1="0"
          y2="19.2"
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset="0" stopColor="#FE7165" />
          <Stop offset="1" stopColor="#FF8D78" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
